module.exports = __webpack_public_path__ + "static/logo-rv-main-acaab2d7dba63990c9d05354bc84a0da.png";